import _ from "lodash";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { RootState } from '../../../store/rootReducer';
import useUtil from "../../../hooks/useUtil";
import { IPBTActivitySummary } from "../../../models/statistics.model";
import DownloadButton from "../../DownloadButton";
import moment from "moment";
import exportTable from "../../../lib/exportTable";
import { Table, TableColumnsType } from "antd";

interface IProps {
   res: IPBTActivitySummary[]|undefined;
 }

const Activity = ({res} : IProps)  => {
   const { t } = useTranslation();
   const { getCommonCodeLabel } = useUtil();
   const { campusData } = useSelector((state: RootState) => state.campusData);

   const [data, setData] = useState<IPBTActivitySummary[]>([]);

   useEffect(() => {
      if (res) {
        const newData: any = _.cloneDeep(res);
        
        newData.forEach((item: any, idx: number) => {
          item.rowIdx = idx;
          const campus = campusData.find(campus => campus.campusCode === item.campusCode);
          if (campus) {
            item.campusEngName = campus.campusEngName;
            item.campusKorName = campus.campusKorName;
          } else {
            item.campusEngName = '';
            item.campusKorName = '';
          }
        });
  
        setData(newData);
      }
    }, [res]);

    const onExportTable = () => {
      const _data: any = _.cloneDeep(data);
      _data.forEach((item: any) => {
        item.eduStepCode = getCommonCodeLabel('PR0006', item.eduStepCode);
        item.avgScore = item.avgScore === null ? '-' : Math.floor(item.avgScore);
        if(item.completeCount !== 0) {
         item.CompleteRate = Math.floor((item.completeCount / (item.completeCount + item.inCompleteCount)) * 100) + '%'
      } else {
         item.CompleteRate = '0%';
      }
      });
      const currentDate = moment(new Date());
      exportTable(columns, _data, `PBT(Activity)_(${currentDate.format('YYYYMMDD')})`, `${t('statistics.attendance.Tab1')}`, [12, 12, 12, 12, 15, 10, 10, 10, 10]);
    }

   const columns: TableColumnsType<IPBTActivitySummary> = [
      {
        title: t('common.menu.campus'),
        dataIndex: 'campusKorName',
        key: 'campusKorName',
        align: 'center',
      },
      {
        title: t('common.label.1'),
        dataIndex: 'eduStepCode',
        align: 'center',
        render: value => getCommonCodeLabel('PR0006', value),
      },
      {
        title: t('statistics.dttt.column1'),
        dataIndex: 'courseName',
        key: 'courseName',
        align: 'center',
      },
      {
        title: t('statistics.homework.column5'),
        dataIndex: 'subjectName',
        key: 'subjectName',
        align: 'center',
      },
      {
         title: 'Activity',
         dataIndex: 'activityName',
         key: 'activityName',
         align: 'center',
       },      
      {
         title: t('statistics.dttt.column2'),
         dataIndex: 'avgScore',
         key: 'avgScore',
         align: 'center',
         render: value => value === null ? '-' : Math.floor(value),
      },
      {
         title: t('statistics.homework.column1'),
         dataIndex: 'completeCount',
         key: 'completeCount',
         align: 'center',
      },
       {
         title: t('statistics.homework.column2'),
         dataIndex: 'inCompleteCount',
         key: 'inCompleteCount',
         align: 'center',
       },
       {
         title: t('statistics.homework.column3'),
         dataIndex: 'CompleteRate',
         align: 'center',
         render: (value, record) => {
            if(record.completeCount !== 0) {
               return Math.floor((record.completeCount / (record.completeCount + record.inCompleteCount)) * 100) + '%'
            } else {
               return '0%';
            }
         }
       },
    ];

    return (
      <>
        <div className="comm-table__area">
          <Table
            columns={columns}
            dataSource={data}
            pagination={{
              current: 1,
              pageSize: 999999999,
            }}
            rowKey={'rowIdx'}
          />
        </div>
        <div className="comm-bx__between">
          <DownloadButton onClick={onExportTable} />
        </div>
      </>
    );
}

export default Activity;